import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import { CountryProvider } from "./context/CountryProvider";
import theme from "./theme_ucb";
import { ThemeProvider } from "@mui/material/styles";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { getMsalInstance } from "./pages/mslogin/authConfig";
import { MsalProvider } from "@azure/msal-react";

const root = ReactDOM.createRoot(document.getElementById("root"));

const initializeApp = async () => {
  try {
    const msalInstance = await getMsalInstance();

    root.render(
      <div id="MainDiv">
        <Provider store={store}>
          <BrowserRouter>
            <AuthProvider>
              <CountryProvider>
                <ThemeProvider theme={theme}>
                  <MsalProvider instance={msalInstance}>
                    <App />
                  </MsalProvider>
                </ThemeProvider>
              </CountryProvider>
            </AuthProvider>
          </BrowserRouter>
        </Provider>

        <footer style={{ display: "flex", justifyContent: "center" }}>
          © IQVIA All rights reserved.
        </footer>
      </div>
    );
  } catch (error) {
    console.error("Error initializing app:", error);
    root.render(
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div>Error initializing application. Please refresh the page.</div>
      </div>
    );
  }
};

initializeApp();
reportWebVitals();
